import { jsx as e, jsxs as r } from "react/jsx-runtime";
function n(l) {
  return /* @__PURE__ */ e("svg", { height: "1em", viewBox: "0 0 16 16", width: "1em", ...l, children: /* @__PURE__ */ r("g", { fill: "none", fillRule: "evenodd", children: [
    /* @__PURE__ */ e("path", { d: "M0 0h16v16H0z" }),
    /* @__PURE__ */ e(
      "path",
      {
        d: "M8.694 3.224l6.69 6.443a.822.822 0 01.023 1.163l-.022.022a.89.89 0 01-1.231 0L8 4.926l-6.154 5.926a.888.888 0 01-1.23 0 .822.822 0 01-.023-1.163l.022-.022 6.691-6.443a1 1 0 011.388 0z",
        fill: "currentColor"
      }
    )
  ] }) });
}
export {
  n as default
};
